import Dto from "../../../../../lib/model/service/Dto";

class RemoveCampaign extends Dto {

  campaignId;

  constructor(campaignId = '') {
    super('appl\\service\\campaign\\dto\\RemoveCampaign');
    this.campaignId = campaignId;
  }

  getCampaignId() {
    return this.campaignId;
  }

  setCampaignId(campaignId) {
    this.campaignId = campaignId;
  }

}

export default RemoveCampaign;
